module.exports = __webpack_public_path__ + "img/future_of_xyz.dc3cc4b4.png";